import React from 'react'
import { Sidebar, Chat } from '../components'

const Home = () => {
   return (
      <div className='lg:flex lg:items-center lg:justify-center min-h-screen bg-gray-100 lg:p-12'>
         <div className='grid md:grid-cols-home sm:grid-cols-1 lg:shadow-xl lg:rounded-lg bg-white mx-auto min-h-screen lg:min-h-xl overflow-hidden'>
            <Sidebar />
            <Chat />
         </div>
      </div>
   )
}

export default Home